<template>
  <div class="row">
    <div v-show="locationForbidden" class="alert alert-warning alert-dismissible fade show" style="width: 100%">
      <button
        type="button"
        aria-hidden="true"
        class="close"
        data-dismiss="alert"
        aria-label="Close"
        @click="locationForbidden = null"
      >
        <i class="nc-icon nc-simple-remove" />
      </button>
      <span>
        <b>You cannot view this bible study because it occurred at another location: {{ locationForbidden }}</b></span>
    </div>
    <h5 v-if="loading" style="text-align:center; width:100%">
      Loading...
    </h5>
    <div v-if="!loading && !error" class="col-lg-4 col-md-5">
      <user-card :person="this.person" />
    </div>
    <h3 v-if="error">
      {{ error }}
      <!-- An error ocurred. Try reloading the page or
      confirming that you were added to Discipleship by a staff member. -->
    </h3>
    <div v-if="!loading && !error" class="col-lg-8 col-md-7">
      <card>
        <tabs centered value="Description" tab-content-classes="text-center">
          <tab-pane title="Bible studies leading" key="home">
            <el-switch
              v-model="statusLeading"
              active-text="Led"
              inactive-text="Leading"
            />
            <el-table
              :data="bibleStudiesLeading"
              header-row-class-name="text-primary"
              @row-click="goToBibleStudy"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                prop="name"
                label="Bible Study"
              />
              <el-table-column
                prop="bible_study_schedule.day_of_week"
                label="Day"
              />
              <el-table-column
                prop="bible_study_schedule.meeting_time"
                label="Time"
              />
              <el-table-column
                prop="status"
                label="Status"
              />
              <el-table-column
                prop="start_date"
                label="Start Date"
              />
              <el-table-column
                prop="end_date"
                label="End Date"
              />
            </el-table>
          </tab-pane>
          <tab-pane title="Bible studies attending">
            <el-switch
              v-model="statusAttending"
              active-text="Attended"
              inactive-text="Attending"
            />
            <el-table
              :data="bibleStudiesAttending"
              header-row-class-name="text-primary"
              @row-click="goToBibleStudy"
              :row-class-name="tableRowClassName"
            >
              <el-table-column
                prop="name"
                label="Bible Study"
              />
              <el-table-column
                prop="bible_study_schedule.day_of_week"
                label="Day"
              />
              <el-table-column
                prop="bible_study_schedule.meeting_time"
                label="Time"
              />
              <el-table-column
                prop="status"
                label="Status"
              />
              <el-table-column
                prop="start_date"
                label="Start Date"
              />
              <el-table-column
                prop="end_date"
                label="End Date"
              />
            </el-table>
          </tab-pane>
        </tabs>
      </card>

      <!-- Row for My Notes and Invitation History cards side by side -->
      <div class="row">
        <div :class="invitationCardVisible ? 'col-md-6' : 'col-md-12'">
          <card class="text-center">
            <h5 class="title text-center">
              My notes
            </h5>
            <p>{{ person.user_notes_on_person }}</p>
            <p-button
              type="default"
              outline
              round
              @click="handleEdit()"
              v-if="person.can_be_edited_by_user"
            >
              <i
                class="el-icon-edit el-icon--left"
              /> Edit
            </p-button>
          </card>
        </div>

        <InvitationCardWrapper
          :person="person"
          :loading="loading"
          @visibility-changed="invitationCardVisible = $event"
        />
      </div>
    </div>
    <card>
      <DepthChart
        v-if="person.depth_charts && !loading"
        :person-id="person.id"
      />
    </card>
  </div>
</template>

<script>
import Vue from 'vue';
import {
    mapState
} from 'vuex';
import { Table, TableColumn } from 'element-ui';
import {
    Tabs, TabPane
} from 'src/components/UIComponents';
import UserCard from '../../components/People/UserCard.vue';
import InvitationCardWrapper from '../../components/People/InvitationCardWrapper.vue';
import DepthChart from '../../components/DepthChart/DepthChart';

Vue.use(Table);
Vue.use(TableColumn);

const data = 'People';

export default {
    data() {
        return {
            title: 'PersonShow',
            namespace: 'People',
            loading: false,
            error: '',
            statusLeading: false,
            statusAttending: false,
            bibleStudiesLeading: [],
            bibleStudiesAttending: [],
            locationForbidden: null,
            invitationCardVisible: false,
        };
    },
    components: {
        UserCard,
        InvitationCardWrapper,
        TabPane,
        Tabs,
        DepthChart
    },
    computed: {
        ...mapState({
            person: (state) => state.People.person,
        })
    },
    watch: {
        statusLeading() {
            this.updateTable();
        },
        statusAttending() {
            this.updateTable();
        },
        person() {
            this.updateTable();
        }
    },
    methods: {
        getPersonById(id) {
            this.loading = true;
            this.$store.dispatch(`${this.namespace}/getPersonById`,
                { personId: this.$route.params.id }).then(() => { this.loading = false; }).catch((error) => {
                this.loading = false; this.error = error.response.data.message;
            });
        },
        handleEdit() {
            this.$router.push({ name: 'PersonEdit', params: { id: this.$route.params.id } });
        },
        goToBibleStudy(row) {
            if (row.is_at_users_location) {
                this.$router.push({ name: 'BibleStudiesView', params: { id: row.id } });
            } else {
                this.locationForbidden = row.location;
            }
        },
        tableRowClassName({ row, rowIndex }) {
            return 'clickable-paragraph';
        },
        updateTable() {
            if (this.statusLeading) {
                this.bibleStudiesLeading = this.$store.state.People.person.ended_bible_study_leader;
            } else {
                this.bibleStudiesLeading = this.$store.state.People.person.active_bible_study_leader;
            }
            if (this.statusAttending) {
                this.bibleStudiesAttending = this.$store.state.People.person.ended_bible_study_participant;
            } else {
                this.bibleStudiesAttending = this.$store.state.People.person.active_bible_study_participant;
            }
        },
        formatDate(dateString) {
            if (!dateString) return '';
            const date = new Date(dateString);
            return date.toLocaleDateString();
        }
    },
    created() {
        this.getPersonById();
        this.updateTable();
        this.$store.commit('People/setError', '');
    },
    beforeDestroy() {
        // todo destroy the state.
    }
};
</script>
<style scoped>
</style>
